module.exports = __webpack_public_path__ + "static/media/homepage-changing-screens.0ee163d3.webm";